import { StepIntoIcon } from '@/svgs/discover-benzatine'
import React from 'react'

function StepInto() {
   return (
      <section className="info_tell h-auto overview_career">
         <div className="container container-xxl">
            <div className="row justify-content-center text-center">
               <div className="col-xl-12 col-xl-10">
                  <p className="discover_subtitle">Our Recruitment Process</p>
                  <h2 className="section_heading_title mb-3 tech_title">
                     Step Into Your Future with Us
                  </h2>
                  <p className="info_tell_description mb-4">
                     At Benzatine Infotech, we believe in making recruitment a
                     smooth, transparent, and engaging journey. Our hiring{' '}
                     <br />
                     process is designed to connect with top talent efficiently,
                     ensuring every candidate experiences a welcoming and
                     professional approach.
                  </p>
               </div>
               <div className="overview_career_icon">
                  <StepIntoIcon />
               </div>
            </div>
         </div>
      </section>
   )
}

export default StepInto
